import React from 'react'
import { cn } from '@/lib/utils'

interface ProgressProps extends React.HTMLAttributes<HTMLDivElement> {
  value?: number
  max?: number
  color?: string
  striped?: boolean
  animated?: boolean
  bar?: boolean
}

const colorMap: Record<string, string> = {
  primary: 'bg-primary',
  success: 'bg-[hsl(var(--success))]',
  info: 'bg-[hsl(var(--info))]',
  warning: 'bg-[hsl(var(--warning))]',
  danger: 'bg-destructive',
}

export const Progress: React.FC<ProgressProps> = ({
  value = 0, max = 100, color = 'primary', className, children, ...props
}) => (
  <div className={cn('w-full bg-muted rounded-full h-2.5', className)} {...props}>
    <div
      className={cn('h-full rounded-full transition-all', colorMap[color])}
      style={{ width: `${Math.min((value / max) * 100, 100)}%` }}
    />
  </div>
)
